import { createConsumer } from '@rails/actioncable';

// Automatically use ws:// for dev, wss:// for production
const protocol = window.location.protocol === 'https:' ? 'wss://' : 'ws://';
const domain = window.location.host; // includes hostname + port (important for localhost:3000)
const url = `${protocol}${domain}/cable`;

export default createConsumer(url);
